"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSelectError = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _ContentLayout = require("../ContentLayout");
var styles = _interopRequireWildcard(require("./AccountSelectError.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AccountSelectError = _ref => {
  let {
    onRetry,
    onChangeAccount
  } = _ref;
  return /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("div", {
    className: styles['buttons']
  }, /*#__PURE__*/React.createElement(_uiKit.Button, {
    "data-name": "RetryByPhoneBtn",
    theme: "fill_primary",
    fullWidth: true,
    onClick: onRetry
  }, "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437"), /*#__PURE__*/React.createElement(_uiKit.Button, {
    "data-name": "BackToAccountSelectBtn",
    theme: "fill_secondary",
    fullWidth: true,
    onClick: onChangeAccount
  }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442")));
};
exports.AccountSelectError = AccountSelectError;